import fromPairs from 'lodash/fromPairs';
import groupBy from 'lodash/groupBy';
import mapValues from 'lodash/mapValues';
import sumBy from 'lodash/sumBy';

import { getProductLabel } from '../../campaign-editor/transform-for-rendering';
import { WRITABLE_BUDGET_FIELDS } from '../change-product-budget/constants';
import { getProductRowId } from '../change-product-budget/utils';
import MoveBudgetToWalletComment from './MoveBudgetToWalletComment';
import MoveBudgetToWalletForm from './MoveBudgetToWalletForm';
import patch from './patch';

export default {
  label: 'Move Budget To Wallet',
  value: 'Move Budget To Wallet',
  superuserOnly: true,
  Form: MoveBudgetToWalletForm,
  Comment: MoveBudgetToWalletComment,
  initialState(campaign, campaignLinesById) {
    const campaignLines = Object.values(campaignLinesById);
    const campaignLinesByProductRowId = groupBy(campaignLines, getProductRowId);

    const roundToTwoDecimals = value => parseFloat(value.toFixed(2));

    return {
      delta: 0,
      productAggregates: mapValues(campaignLinesByProductRowId, lines => {
        const rep = lines[0]; // representative line

        const values = fromPairs(
          WRITABLE_BUDGET_FIELDS.map(budgetField => [
            budgetField,
            roundToTwoDecimals(sumBy(lines, budgetField)),
          ]),
        );

        const { product } = rep;
        return {
          label: getProductLabel(product),
          product,
          // TransformForRendering func changes it to % value which leads to wrong values while calculating the spendable budget.
          // Hence it is converted back to a value b/w 0 and 1.
          adjustedFee: rep.adjustedFee / 100 || 0,
          lineIds: lines.map(({ id }) => id),
          oldValues: values,
          newValues: values,
        };
      }),
    };
  },
  patch,
};
